<template>
  <div class="notification" v-if="userListLoaded && typeListLoaded || userListLoaded && typeApproveListLoaded" @click.stop>
    <div class="notification__creator" v-if="notification.itemable_type === 'App\\Models\\Task\\TaskProcess'">
      <div class="user-avatar notifications-avatar">
        <img v-if="getFullUser(taskOwnerId).avatar !== null && getFullUser(taskOwnerId).avatar.file_size"
             :src="getFullUser(taskOwnerId).avatar.url" :alt="getFullUser(taskOwnerId).name">
        <img v-else src="/img/avatar-thumb.png" :alt="getFullUser(taskOwnerId).name">
      </div>
    </div>

    <div class="notification__body" v-if="notification.itemable_type === 'App\\Models\\Task\\TaskProcess'">
      <div class="notification__close" v-if="removable" @click.stop="removeNotification(notification.id)">
        <svg width="12" height="12" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 1L16 16" stroke="currentColor" stroke-width="2"/>
          <path d="M1 16L16 1" stroke="currentColor" stroke-width="2"/>
        </svg>
      </div>
      <div class="notification__creator-info" @click.stop="goToCreator">
        {{ getFullUser(taskOwnerId).name }}
      </div>
      <div class="notification__task">
        <span class="notification__text">{{ getTypeDescription() }}:&nbsp;</span>
        <div class="link" @click.stop="goToTask">{{ getTask().name }}</div>
      </div>
      <div class="notification__assignee" v-if="assigneesTo.length">
        <span class="notification__text">Ответственные:&nbsp;</span>
        <span class="notification__assignee-user" v-for="user in assigneesTo" :key="user.id">
          {{ user.profile.surname }} {{ user.profile.name }}
        </span>
      </div>
      <!--type === 2 это тип уведомления о добавлении комментария-->
      <div class="notification__comment plain-html" v-if="notification.itemable && notification.itemable.type === 2 && notification.itemable.comment">
        <span class="notification__text">Комментарий:&nbsp;</span>
        <!--нужно как-то обрезать текст комментария, но по длине ориентироваться нельзя, так-как поле содержит html символы и длина становится не адекватной-->
        <span v-html="notification.itemable.comment.text"></span>
      </div>
      <div class="notification__column-transfer" v-if="notification.itemable && notification.itemable.column_from && notification.itemable.column_to">
        <div class="notification__column from" :class="notification.itemable.column_from.color">{{ notification.itemable.column_from.name }}</div>
        <div class="notification__column-transfer-icon">
          <svg width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L7 7L13 1" stroke="currentColor" stroke-width="2"/>
          </svg>
        </div>
        <div class="notification__column to" :class="notification.itemable.column_to.color">{{ notification.itemable.column_to.name }}</div>
      </div>
      <div class="notification__date">{{ formatDateTime(notification.created_at) }}</div>
    </div>

    <div class="notification__body" v-if="notification.itemable_type === 'App\\Models\\Event\\Activity'">
      <div class="notification__close" v-if="removable" @click.stop="removeNotification(notification.id)">
        <svg width="12" height="12" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 1L16 16" stroke="currentColor" stroke-width="2"/>
          <path d="M1 16L16 1" stroke="currentColor" stroke-width="2"/>
        </svg>
      </div>
      <div class="notification__title" style="cursor: pointer" @click.stop="showEventDetailModal(notification.itemable)">{{ notification.itemable.name }}</div>
      <div class="notification__text" v-if="notification.itemable.address">Место проведения: {{ notification.itemable.address }}</div>
      <div class="notification__text">Дата и время начала: {{ formatDateTime(notification.itemable.start_at) }}</div>
      <div class="event-description__publish">{{ formatDate(notification.created_at) }}</div>
    </div>

    <div class="notification__body" v-if="notification.itemable_type === 'App\\Models\\Approve\\ApproveProcess'">
      <div class="notification__close" v-if="removable" @click.stop="removeNotification(notification.id)">
        <svg width="12" height="12" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 1L16 16" stroke="currentColor" stroke-width="2"/>
          <path d="M1 16L16 1" stroke="currentColor" stroke-width="2"/>
        </svg>
      </div>
      <div class="notification__creator-info" @click.stop="goToCreatorApprove">
        {{ getFullUser(notificationApprove.owner_id).name }}
      </div>
      <div class="notification__task">
        <span class="notification__text">{{ getTypeApproveDescription(notification.itemable.type) }}:&nbsp;</span>
        <div class="link" @click.stop="goToApprove">{{ notificationApprove.name }}</div>
      </div>
      <div class="notification__assignee" v-if="responsiblesTo.length">
        <span class="notification__text">Ответственные:&nbsp;</span>
        <span class="notification__assignee-user" v-for="user in responsiblesTo" :key="user.id">
          {{ user.profile.surname }} {{ user.profile.name }}
        </span>
      </div>
      <div class="notification__assignee" v-if="controlsId.length">
        <span class="notification__text">Контролирующие:&nbsp;</span>
        <span class="notification__assignee-user" v-for="user in controlsId" :key="user.id">
          {{ user.profile.surname }} {{ user.profile.name }}
        </span>
      </div>
      <!--type === 2 это тип уведомления о добавлении комментария-->
      <div class="notification__comment plain-html" v-if="notification.itemable.type === 2 && notification.itemable.comment">
        <span class="notification__text">Комментарий:&nbsp;</span>
        <!--нужно как-то обрезать текст комментария, но по длине ориентироваться нельзя, так-как поле содержит html символы и длина становится не адекватной-->
        <span v-html="notification.itemable.comment.text"></span>
      </div>
      <!--type === 5 это тип уведомления о голосовании -->
      <div class="notification__comment plain-html" v-if="notification.itemable.type === 5 && notification.itemable.voted_id">
        <span class="notification__text">Проголосовал:&nbsp;</span>
        <span class="notification__assignee-user">
          {{ getFullUser(notification.itemable.voted_id).name }}
        </span>
      </div>
      <div class="notification__date">{{ formatDateTime(notification.created_at) }}</div>
    </div>

    <div class="notification__body" v-if="notification.itemable_type === 'App\\Models\\Event\\EventMessage'">
      <div class="notification__close" v-if="removable" @click.stop="removeNotification(notification.id)">
        <svg width="12" height="12" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 1L16 16" stroke="currentColor" stroke-width="2"/>
          <path d="M1 16L16 1" stroke="currentColor" stroke-width="2"/>
        </svg>
      </div>
      <span>
        Новый <router-link :to="{ name: 'Feed', params: { postId: notification.itemable.id } }" class="post__link">пост</router-link> от:
      </span>
      <div>
         {{ getFullUser(notification.owner_id).name }}
      </div>
      <div class="event-description__publish">{{ formatDate(notification.created_at) }}</div>
    </div>

    <div class="notification__body" v-if="notification.itemable_type === 'App\\Models\\Event\\EventMessageComment'">
      <div class="notification__close" v-if="removable" @click.stop="removeNotification(notification.id)">
        <svg width="12" height="12" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 1L16 16" stroke="currentColor" stroke-width="2"/>
          <path d="M1 16L16 1" stroke="currentColor" stroke-width="2"/>
        </svg>
      </div>
      <span>
        Новый <router-link :to="{ name: 'Feed', params: { postId: notification.post_id } }" class="post__link">комментарий</router-link> от:
      </span>
      <div>
        {{ getFullUser(notification.sender_id).name }}
      </div>
      <div class="event-description__publish">{{ formatDate(notification.created_at) }}</div>
    </div>

    <!-- новые типы Уведомлений (сделаны без макета) -->
    <div class="notification__body" v-if="notification.itemable_type === 'App\\Models\\Approve\\Approve'">
      <div class="notification__close" v-if="removable" @click.stop="removeNotification(notification.id)">
        <svg width="12" height="12" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 1L16 16" stroke="currentColor" stroke-width="2"/>
          <path d="M1 16L16 1" stroke="currentColor" stroke-width="2"/>
        </svg>
      </div>
      <span v-if="notification.type == 'approve-create'">
        Новый лист согласования 
        <router-link :to="{ name: 'ApproveUpdate_main', params: { id: notification.id } }" class="post__link">
          {{ notification.name }}
        </router-link> 
        от: 
        <div>
          {{ getFullUser(notification.user_id).name }}
        </div>
      </span>

      <span v-else-if="notification.type == 'approve-voted'">
        Пользователь {{ getFullUser(notification.user_voted_id).name }} проголосовал в листе согласования
        <router-link :to="{ name: 'ApproveUpdate_main', params: { id: notification.id } }" class="post__link">
          {{ notification.name }}
        </router-link> 
      </span>

      <div class="event-description__publish">{{ formatDate(notification.created_at) }}</div>
    </div>

    <div class="notification__body" v-if="notification.itemable_type === 'App\\Models\\Approve\\ApproveComment'">
      <div class="notification__close" v-if="removable" @click.stop="removeNotification(notification.id)">
        <svg width="12" height="12" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 1L16 16" stroke="currentColor" stroke-width="2"/>
          <path d="M1 16L16 1" stroke="currentColor" stroke-width="2"/>
        </svg>
      </div>
      <span>
        Новый комментарий к листу согласования
        <router-link :to="{ name: 'ApproveUpdate_main', params: { id: notification.id } }" class="post__link">
          {{ notification.name }}
        </router-link> 
      </span>
      <div class="event-description__publish">{{ formatDate(notification.created_at) }}</div>
    </div>

    <div class="notification__body" v-if="notification.itemable_type === 'App\\Models\\Task\\Comment'">
      <div class="notification__close" v-if="removable" @click.stop="removeNotification(notification.id)">
        <svg width="12" height="12" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 1L16 16" stroke="currentColor" stroke-width="2"/>
          <path d="M1 16L16 1" stroke="currentColor" stroke-width="2"/>
        </svg>
      </div>
      <span>
        Новый 
        <router-link :to="{ name: 'TaskInfo', params: { id: notification.task_id } }" class="post__link">
          комментарий 
        </router-link>
        к задаче от:
        <div>
          {{ getFullUser(notification.owner_id).name }}
        </div>
      </span>
      <div class="event-description__publish">{{ formatDate(notification.created_at) }}</div>
    </div>

    <div class="notification__body" v-if="notification.itemable_type === 'App\\Models\\Poll\\Poll'">
      <div class="notification__close" v-if="removable" @click.stop="removeNotification(notification.id)">
        <svg width="12" height="12" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 1L16 16" stroke="currentColor" stroke-width="2"/>
          <path d="M1 16L16 1" stroke="currentColor" stroke-width="2"/>
        </svg>
      </div>
      <span>
        Новый 
        <router-link :to="{ name: 'Feed', params: { postId: notification.itemable.id } }" class="post__link">
          опрос
        </router-link> от:
      </span>
      <div>
        {{ getFullUser(notification.owner_id).name }}
      </div>
      <div class="event-description__publish">{{ formatDate(notification.created_at) }}</div>
    </div>

    <div class="notification__body" v-if="notification.itemable_type === 'App\\Models\\Task\\Task'">
      <div class="notification__close" v-if="removable" @click.stop="removeNotification(notification.id)">
        <svg width="12" height="12" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 1L16 16" stroke="currentColor" stroke-width="2"/>
          <path d="M1 16L16 1" stroke="currentColor" stroke-width="2"/>
        </svg>
      </div>
      <span>
        Задача
        <router-link :to="`/task/info/${notification.id}`" class="post__link">
          {{ notification.name }} 
        </router-link> {{ taskType }}
      </span>
      <div class="event-description__publish">{{ formatDate(notification.created_at) }}</div>
    </div>

    <div class="notification__body" v-if="notification.itemable_type === 'App\\Models\\Pto\\Ppr'">
      <div class="notification__close" v-if="removable" @click.stop="removeNotification(notification.id)">
        <svg width="12" height="12" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 1L16 16" stroke="currentColor" stroke-width="2"/>
          <path d="M1 16L16 1" stroke="currentColor" stroke-width="2"/>
        </svg>
      </div>
      <span>
        Новый ППР 
        <router-link :to="{ name: 'PtoProjectPtoPPRUpdate', params: { id: notification.id } }" class="post__link">
          {{ notification.itemable.name }}
        </router-link> 
         по проекту 
        <router-link :to="{ name: 'PtoProjectUpdate', params: { id: notification.itemable.project.id } }" class="post__link">
          {{ notification.itemable.project.name }}
        </router-link> 
      </span>
      <div class="event-description__publish">{{ formatDate(notification.created_at) }}</div>
    </div>
  </div>

</template>

<script>
import { formatDateTime } from '@/utils/utils'

export default {
  name: 'app-notification',
  props: {
    notification: Object,
    removable: {
      type: Boolean,
      default: false
    },
    popUp: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {}
  },
  computed: {
    // нужно убедится что списки загружены (для методов-геттеров), иначе лишние ошибки в консоли
    userListLoaded () {
      return this.$store.getters['[dictionaries] usersList'].length
    },
    typeListLoaded () {
      return this.$store.getters['[dictionaries] taskNotificationTypes'].length
    },
    typeApproveListLoaded () {
      return this.$store.getters['[dictionaries] approveNotificationTypes'].length
    },
    taskOwnerId () {
      return this.notification?.itemable?.task?.owner_id
    },
    assigneesTo () {
      return this.notification?.itemable?.assignees_to || []
    },
    responsiblesTo () {
      return this.notification?.itemable?.responsibles_to || []
    },
    controlsId () {
      return this.notification?.itemable?.controls_id || []
    },
    notificationApprove () {
      return this.notification?.itemable?.approve || {}
    },
    taskType () {
      switch (this.notification.type) {
        case 'task-complete':
          return 'завершена'
        case 'task-create':
          return 'создана'
        case 'task-start':
          return 'в работе'
        default:
          return ''
      }
    }
  },
  methods: {
    removeNotification (notificationId) {
      this.$emit('remove-notification', notificationId)
    },
    closeWidget () {
      this.$emit('close-widget')
    },
    goToCreator () {
      // проверка нужна для того чтобы исключить переход на текущий маршрут, иначе роутер выбрасывает ошибку
      const targetPath = `/user/info/${this.notification.itemable?.task?.owner_id || this.notification.owner_id}/personal`
      const currentPath = this.$router.currentRoute.path

      if (currentPath !== targetPath) {
        this.$router.push({ path: targetPath })
      }
      this.closeWidget()
    },
    goToCreatorApprove () {
      // проверка нужна для того чтобы исключить переход на текущий маршрут, иначе роутер выбрасывает ошибку
      const targetPath = `/user/info/${this.notification.itemable.approve.owner_id}/personal`
      const currentPath = this.$router.currentRoute.path

      if (currentPath !== targetPath) {
        this.$router.push({ path: targetPath })
      }
      this.closeWidget()
    },
    goToTask () {
      // проверка нужна для того чтобы исключить переход на текущий маршрут, иначе роутер выбрасывает ошибку
      const targetPath = `/task/info/${this.notification.itemable.task.id}`
      const currentPath = this.$router.currentRoute.path

      if (currentPath !== targetPath) {
        this.$router.push({ path: targetPath })
      }
      this.closeWidget()
    },
    goToApprove () {
      // проверка нужна для того чтобы исключить переход на текущий маршрут, иначе роутер выбрасывает ошибку
      const targetPath = `/approve/update/${this.notification.itemable.approve.id}`
      const currentPath = this.$router.currentRoute.path

      if (currentPath !== targetPath) {
        this.$router.push({ path: targetPath })
      }
      this.closeWidget()
    },
    formatDate (date) {
      return formatDateTime(date)
    },
    formatDateTime (date) {
      return formatDateTime(date)
    },
    getTypeDescription () {
      const type = this.notification?.itemable?.type
      if (type) {
        return this.$store.getters.getTaskNotificationTypeByValue(type)
      }
      return ''
    },
    getTypeApproveDescription (type) {
      return this.$store.getters.getApproveNotificationTypeByValue(type)
    },
    getFullUser (id) {
      return this.$store.getters.getFullUserById(id) || { avatar: null, name: '' }
    },
    getTask () {
      return this.notification?.itemable?.task || {}
    },
    showEventDetailModal (item) {
      this.$emit('show-event-modal', item)
    }
  },
  mounted () {
    // if (this.popUp) {
    //   setTimeout(() => this.removeNotification(this.notification.id), 30000)
    // }
  }
}

</script>

<style lang="scss" scoped>
@import '../../assets/css/system/_vars';
@import '../../assets/css/system/_mixins';

.notification {
  display: flex;
  width: 540px;
  background: $color_sixth;
  border-radius: 3px;
  box-shadow: 0 4px 4px rgba(17, 112, 184, 0.25);
  overflow: hidden;

  @media screen and (max-width: $tablet_start) {
    width: 100%;
    max-width: 540px;
  }

  &__creator {
    background: $color_second;
    padding: 16px 10px;
  }

  &__creator-info {
    display: block;
    font-weight: bold;
    color: $font_color_third;
    transition: .3s;
    margin-bottom: 6px;
    padding-right: 30px;
    cursor: pointer;

    &:hover {
      opacity: .7;
    }
  }

  .post__link {
    color: $font_color_third;
    font-weight: bold;
    transition: .3s;

    &:hover {
      opacity: .7;
    }
  }

  &__close {
    position: absolute;
    top: 16px;
    right: 10px;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: center;
    color: #95A4C0;
    cursor: pointer;
    @include size(20px);
    margin-left: auto;
    transition: .3s;

    &:hover {
      color: $color_second-light;
    }
  }

  &__body {
    flex: 1;
    position: relative;
    display: flex;
    flex-flow: column;
    align-items: flex-start;
    color: $font_color_second;
    padding: 16px 20px 10px 20px;
    font-size: 14px;
  }

  &__assignee-user {
    &::after {
      content: ',';
      display: inline-block;
    }

    &:last-child {
      &::after {
        content: ',';
        display: none;
      }
    }
  }

  &__date {
    font-size: 12px;
    line-height: 1;
    color: $color_second-light;
    margin-left: auto;
  }

  &__column-transfer {
    margin-top: 10px;
    display: flex;
    flex-flow: row nowrap;
  }

  &__column-transfer-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 5px;
    margin-left: 5px;
    transform: rotate(270deg);
  }

  &__column {
    color: $font_color_alt;
    padding: 2px 10px;
    border-radius: 3px;

    &:last-child {
      margin-right: 0;
    }

    &.blue {
      background: #2278BA;
      background: linear-gradient(90deg, #6672B1 0%, #2278BA 100%);
    }

    &.orange {
      background: #F86758;
      background: linear-gradient(95.94deg, #FAA658 -20.08%, #F86758 122.58%);
    }

    &.pink {
      background: #D75798;
      background: linear-gradient(102.64deg, #E8506F 9.26%, #D75798 100%);
    }

    &.green {
      background: #83BC70;
      background: linear-gradient(90deg, #559E97 -18.5%, #83BC70 119.25%);
    }

    &.purple {
      background: #790D7F;
      background: linear-gradient(90deg, #BC1183 -18.5%, #790D7F 119.25%);
    }

    &.violet {
      background: #143568;
      background: linear-gradient(90deg, #6E34B8 -18.5%, #143568 119.25%);
    }
  }

  &__title {
    display: block;
    font-weight: bold;
    color: $font_color_third;
    margin-bottom: 6px;
  }
}

.notifications-avatar {
  @include size(42px);
}

.event-description__publish {
  width: 100%;
  text-align: right;
  padding: 8px 0 0;
  font-size: 12px;
}
</style>
